import React from "react";
import aboutimg from "../../pages/assets/aboutusimg1.jpg";

const AboutSection1 = () => {
  return (
    <div className="bg-white mx-5">
      <div className="flex flex-wrap gap-5 justify-center">
        <div className="flex flex-col md:flex-row gap-5 items-center lg:mt-20 w-full max-w-7xl">
          {/* Text Section */}
          <div className="flex flex-col gap-3 mb-5 w-full md:w-1/2">
            <h2 className="text-[30px] xs:text-[40px] sm:text-[50px] md:text-[60px] text-primary-950 mb-3 leading-tight tracking-tighter">
              About Us: Your Partner In Smart Crypto Investments
            </h2>
            <p className="text-sm sm:text-base">
              At <b>Probi Mining</b>, we’re not just a crypto investment
              platform — we’re your dedicated partner in navigating the
              ever-changing world of digital assets. Founded by a team of
              financial experts, tech innovators, and passionate crypto
              enthusiasts, our mission is to bridge the gap between traditional
              finance and the future of decentralized markets. Our approach is
              built on three pillars: transparency, security, and innovation. In
              an industry that can feel overwhelming and volatile, we offer
              clear insights, real-time analytics, and expert guidance,
              empowering you to make informed investment decisions. We
              understand that every investor’s journey is unique, which is why
              our platform is designed to accommodate a wide range of
              strategies, from those just starting to explore the world of
              cryptocurrency to seasoned professionals looking for sophisticated
              trading tools. With Probi Mining, you’ll find a seamless, secure,
              and intuitive experience that puts your financial goals first. As
              a forward-thinking company, we leverage cutting-edge technology
              and advanced algorithms to optimize your investment opportunities.
              Our expert team continually monitors market trends to ensure you
              are equipped with the knowledge and resources you need to stay
              ahead of the curve.
            </p>
          </div>

          {/* Image Section */}
          <div className="w-full md:w-1/2 flex justify-center">
            <img
              src={aboutimg}
              alt="about-image"
              className="w-full h-auto max-w-[800px] rounded-lg shadow-lg object-cover"
            />
          </div>
        </div>

        {/* Second Section */}
        <div className="flex flex-col gap-5 w-full max-w-7xl">
          <div className="flex flex-col gap-3">
            <h2 className="text-primary-950">Proven Expertise</h2>
            <p>
              Our team brings years of experience in both traditional finance
              and cryptocurrency markets to deliver top-notch solutions tailored
              to your needs.
            </p>
          </div>
          <hr />

          <div className="flex flex-col gap-3">
            <h2 className="text-primary-950">Comprehensive Tools</h2>
            <p>
              From real-time market data to advanced portfolio management, our
              tools are designed for both beginner and advanced traders.
            </p>
          </div>
          <hr />

          <div className="flex flex-col gap-3">
            <h2 className="text-primary-950">
              Security First: Trading You Can Trust
            </h2>
            <p>
              We prioritize your safety with robust encryption and secure
              trading protocols, ensuring peace of mind with every transaction.
            </p>
          </div>
          <hr />

          <div className="flex flex-col gap-3">
            <h2 className="text-primary-950">Global Reach</h2>
            <p>
              Access investment opportunities from around the world with our
              diverse portfolio of assets and currencies.
            </p>
          </div>
          <hr />
        </div>
      </div>
    </div>
  );
};

export default AboutSection1;
